import { render, staticRenderFns } from "./Vk.vue?vue&type=template&id=360d6557&scoped=true&"
import script from "./Vk.vue?vue&type=script&lang=js&"
export * from "./Vk.vue?vue&type=script&lang=js&"
import style0 from "./Vk.vue?vue&type=style&index=0&id=360d6557&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360d6557",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/admin/workspace/ss/ss-web-game/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('360d6557')) {
      api.createRecord('360d6557', component.options)
    } else {
      api.reload('360d6557', component.options)
    }
    module.hot.accept("./Vk.vue?vue&type=template&id=360d6557&scoped=true&", function () {
      api.rerender('360d6557', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/social/Vk.vue"
export default component.exports